import React from 'react';

const DEFAULT_CONTEXT = {
  contextData: {
    activeNavHoverId: undefined,
    showOpaqueHeader: false,
  },
};

const ContextStateContext = React.createContext(DEFAULT_CONTEXT);

/* eslint-disable no-unused-vars */
const ContextDispatchContext = React.createContext(
  /** @type {React.Dispatch<{ contextData: object, type: ('set') }>} */ ({
    contextData,
  }) => {},
);
/* eslint-enable no-unused-vars */

/**
 * @param {React.ReducerState<React.Reducer<any, any>>} state
 * @param {React.ReducerAction<React.Reducer<any, any>>} action
 */
function contextReducer(state, action) {
  switch (action.type) {
    case 'set': {
      return {
        contextData: action.contextData ? action.contextData : null,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {{ contextData: object }=} props.defaultValues
 */
function ContextProvider({ children, defaultValues = DEFAULT_CONTEXT }) {
  const [state, dispatch] = React.useReducer(contextReducer, defaultValues);
  return (
    <ContextStateContext.Provider value={state}>
      <ContextDispatchContext.Provider value={dispatch}>
        {children}
      </ContextDispatchContext.Provider>
    </ContextStateContext.Provider>
  );
}
function contextState() {
  const context = React.useContext(ContextStateContext);
  if (context === undefined) {
    throw new Error('contextState must be used within a ContextProvider');
  }
  return context;
}

function contextDispatch() {
  const context = React.useContext(ContextDispatchContext);
  if (context === undefined) {
    throw new Error('contextDispatch must be used within a ContextProvider');
  }
  return context;
}

export { ContextProvider, contextState, contextDispatch };
